document.addEventListener('DOMContentLoaded', function () {
    const loginRoot = document.querySelector('.lapri-login');
    const loginInput = document.getElementById('login_field');
    const loginSubmit = document.getElementById('login_submit');
    const auth0Link = document.getElementById('auth0_login_link');
    const passwordInput = document.querySelector('input[type="password"]');

    if (!loginRoot || !loginInput || !auth0Link) {
        return;
    }

    const lastLoggedInEmail = loginRoot.dataset.lastLoggedInEmail;
    const needAuth0Login = loginRoot.dataset.needAuth0Login;

    // URLパラメータのチェック
    const urlParams = new URLSearchParams(window.location.search);
    const forceForm = urlParams.get('force_form') === '1';

    function isSsoLoginDomain(email) {
        return email.match(/@(.*\.)?lline-group\.co\.jp$/);
    }

    function updateLoginUI() {
        const email = loginInput.value;
        const isDomain = isSsoLoginDomain(email);

        // force_form=1の場合は通常のフォームを強制表示
        if (isDomain && !forceForm) {
            passwordInput.disabled = true;
            loginSubmit.style.display = "none";
            auth0Link.style.display = "";
            const baseUrl = auth0Link.getAttribute('href').split('?')[0];
            if (needAuth0Login === "true") {
                auth0Link.setAttribute('href', `${baseUrl}?login_hint=${encodeURIComponent(email)}&prompt=login`);
                auth0Link.click();
            } else if (email === lastLoggedInEmail) {
                auth0Link.setAttribute('href', `${baseUrl}?login_hint=${encodeURIComponent(email)}&prompt=none`);
            } else {
                auth0Link.setAttribute('href', `${baseUrl}?login_hint=${encodeURIComponent(email)}&prompt=login`);
            }
        } else {
            passwordInput.disabled = false;
            loginSubmit.style.display = "";
            auth0Link.style.display = "none";
        }
    }

    // EnterキーでSSOログイン発火
    loginInput.addEventListener('keydown', function(e) {
        const email = loginInput.value;
        if (isSsoLoginDomain(email) && !forceForm && e.key === 'Enter') {
            e.preventDefault();
            auth0Link.click();
        }
    });

    loginInput.addEventListener('input', updateLoginUI);
    updateLoginUI();
});

window.addEventListener('pageshow', function() {
    const loginInput = document.getElementById('login_field');
    if (loginInput) loginInput.dispatchEvent(new Event('input'));
});
